import { useTranslation } from 'react-i18next';
import { GlobalLabelProps } from './types';

export const GlobalLabel = ({ isGlobal }: GlobalLabelProps) => {
    const { t } = useTranslation();
    return isGlobal ? (
        <span data-testid="globalLabel" className="bg-primary inline-block text-xs py-0.5 px-2 -ms-1 me-1 rounded-full text-on-primary whitespace-nowrap">
            {t('Player.Chat.Global')}
        </span>
    ) : null;
};
